export interface IQuoteUploadPayload {
  vendor: string | undefined;
  quoteNumber: string | undefined;
  quoteDate: string | undefined;
  contractType?: string | undefined;
  contractDate?: string | undefined;
  user: string | undefined;
  commodity: string | undefined;
  file: File | undefined;
}

export interface IDeleteQuotePayload {
  userEmail: string | null;
  district: string | null;
  supplier: string | null;
  contractValidity: string | null;
  quote_id: string | null;
  contractType: string | null;
}

export interface IAdditionalInputPayload {
  projectedReleaseDate?: string;
  email: string | null;
  commodity: string | undefined;
  date?: Date;
  file: File | undefined;
  uploadType: "uploadProjectedRelease" | "uploadAgentPricing" | undefined;
}

export interface IAdditionalInputIndexPayload {
  commodity: string | undefined;
  close: number | null;
  month: string | null;
  email: string | null;
}

export interface IIndexValuesPayload {
  commodity: string | undefined;
  email: string | null;
}

export interface IVendorDropdownObject {
  vendor: string;
}
export interface IQuoteNumberDropdownObject {
  quoteNumber: string;
  quoteName: string;
}

//Popup Dropdown Response
export interface IQuoteUploadMetaData {
  vendors: IVendorDropdownObject[];
  quotes: IQuoteNumberDropdownObject[];
}

export const metaDataSteelConduit: IQuoteUploadMetaData = {
  vendors: [
    { vendor: "ATKORE" },
    { vendor: "ZEKELMAN" },
    { vendor: "NUCOR" },
    { vendor: "JM EAGLE" },
  ],
  quotes: [
    { quoteNumber: "1", quoteName: "1" },
    { quoteNumber: "2", quoteName: "2" },
    { quoteNumber: "3", quoteName: "3" },
    { quoteNumber: "10", quoteName: "Mid Month" },
  ],
};
export const metaDataPvcConduit: IQuoteUploadMetaData = {
  vendors: [
    { vendor: "ATKORE" },
    { vendor: "CANTEX" },
    { vendor: "IPEX" },
    { vendor: "NATIONAL PIPE" },
    { vendor: "PRIME CONDUIT" },
    { vendor: "SOUTHERN PIPE" },
    { vendor: "ZEKELMAN" },
    { vendor: "JM EAGLE" },
  ],
  quotes: [
    { quoteNumber: "1", quoteName: "1" },
    { quoteNumber: "2", quoteName: "2" },
    { quoteNumber: "3", quoteName: "3" },
    { quoteNumber: "10", quoteName: "Mid Month" },
  ],
};

//Payload to get quote upload status
export interface IQuoteUploadStatusPayload {
  commodity: string;
  quotation_date: string;
}

//Response for Upload Status for quotes
export interface IQuoteUploadStatusResponse {
  vendor: string;
  firstQuote: string;
  secondQuote: string;
  thirdQuote: string;
}

export interface IGetWireStatusResponse {
  data: {
    Suppliers?: string[];
    summary?: Record<string, Record<string, string[]>>;
    data?: {
      Suppliers?: string[];
      spotSummary?: Record<string, Record<string, [string[], string[]]>>;
      firmFloatSummary?: Record<string, Record<string, [string[], string[]]>>;
      firmFloatSummaryNext?: Record<string, Record<string, [string[], string[]]>>;
      current_negotiation_month?: string;
      next_negotiation_month?: string;
    };
  };
}
export interface ICommodityDropdownObject {
  commodity: string;
}

export interface IAllowAssessmentObject {
  commodity: string;
  allowAssessment: boolean;
}

//Filters Dropdown Response
export interface IQuoteUploadFiltersResponse {
  // projected_release_uploaded_last: string;
  // agent_pricing_uploaded_till: string;
  // index_uploaded_last: string;
  // index_uploaded_by: string;
  // agent_pricing_uploaded_by: string;
  // projected_release_uploaded_by: string;
  commodities: ICommodityDropdownObject[];
  date: string;
  date_wire: string;
  allowAssessment: IAllowAssessmentObject[];
}

export interface IAdditionalInputIndexResponse {
  projected_release_uploaded_last: string;
  agent_pricing_uploaded_till: string;
  index_uploaded_last: string;
  index_uploaded_by: string;
  agent_pricing_uploaded_by: string;
  projected_release_uploaded_by: string;
  indexValues: { month: string; close: number }[];
}

//Combined the payload to submit the quote and refetch the status table
export interface ICombinedQuoteSubmitPayload {
  payload: IQuoteUploadPayload;
  refetchPayload: IQuoteUploadStatusPayload;
}
